/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdCardProps } from './type';

export const cardDefaultProps: TdCardProps = {
  bordered: true,
  headerBordered: false,
  hoverShadow: false,
  loading: false,
  shadow: false,
  size: 'medium',
  theme: 'normal',
};
